import { render, staticRenderFns } from "./CompanyProduct.vue?vue&type=template&id=e5e005a4&scoped=true&"
import script from "./CompanyProduct.vue?vue&type=script&lang=js&"
export * from "./CompanyProduct.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProduct.vue?vue&type=style&index=0&id=e5e005a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e005a4",
  null
  
)

export default component.exports